import React from 'react';
import { Head } from '@inertiajs/react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default function AuthLayout({ children, title, description, user }) {
  return (
    <>
      <Head title={title} />
      <div className="min-h-screen flex flex-col bg-white">
        <Navigation user={user} />

        <div className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full">
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl font-bold text-center">{title}</CardTitle>
                {description && (
                  <CardDescription className="text-center">{description}</CardDescription>
                )}
              </CardHeader>
              <CardContent>
                {children}
              </CardContent>
            </Card>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
